<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="chart-card">
          <h1>Pignoo - 一个开源的迷你ORM框架</h1>
          <p>
            <img src="/img/pignoo.png" style="width: 100px;height: 100px;" alt="pignoo" />
            <el-text tag="b">源码地址：</el-text>
            <el-link href="https://github.com/xsnuo/pignoo">
              https://github.com/xsnuo/pignoo
            </el-link>
          </p>
          <p>
            <el-text tag="b">先看Pignoo的案例。</el-text>
            <el-text>如果觉得Pignoo的数据操作方式正中你的心巴♥️，请继续关注！</el-text>
          </p>
          <div>
            <pre><code class="language-java">{{ code1 }}</code></pre>
          </div>
          <div>
            <pre><code class="language-java">{{ code2 }}</code></pre>
          </div>
          <p>
            <el-text tag="b">Pignoo</el-text>
            <el-text> - 名字来源于《Despicable Me 3》中Minions（小黄人）向Gru（格鲁）抗议生活无聊时喊的词。</el-text>
            <el-text>可能这个词本身没啥意义，但Bilibili上字幕打出的“Pignoo（无聊）”。</el-text>
            <el-text>正巧注意到这个词那天，本项目开始动工。Pignoo这个单词好记又没有任何特指意义，蛮适合用来起名字的。</el-text>
            <el-text>又因为这个词拼写接近Pig，于是项目Logo形象是个戴着Minions同款护目镜的小猪🐷。</el-text>
          </p>
          <p>
            <img src="/img/minions.jpg" style="width: 100%; max-width: 900px;" alt="minions" />
          </p>
          <p>
            <el-text tag="b">Pignoo理念：</el-text>
            <el-text>像操作List一样操作数据库，易用性优先。</el-text>
            <el-text>在纯粹的Pignoo模式下，甚至可以忽视数据库的存在，数据库只是一种将List持久化的载体，一切操作回归List。</el-text>
          </p>
          <p>
            <el-text tag="b">Pignoo目的：</el-text>
            <el-text>在简单的CRUD场景下，极致简化代码量，减少代码分层。</el-text>
            <el-text>（相比其他ORM）让编程者进一步得只关注业务逻辑。</el-text>
          </p>
          <p>
            <el-text tag="b">Pignoo局限与破局：</el-text>
            <el-text>Pignoo不是一个全功能的ORM框架，尤其在较大项目中，它可能满足不了你100%对数据库操作的要求。</el-text>
            <el-text>但是Pignoo侵入性极低，可以轻松和其他主流ORM框架共存，在Spring环境中，甚至可以和其他ORM代码很轻松的编入同一事务。</el-text>
          </p>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  if (window.hljs) {
    window.hljs.highlightAll()
  }
})

const code1 = `@AllArgsConstructor// Lombok - 全参数构造，不必须，只是为了Demo更简洁
@Data// Lombok - 标准JavaBean，Bean是必须的，但可以不使用Lombok
public class Pig {
  private Long id;
  private String name;
}`

const code2 = `public class Test {
  private static DataSource dataSource;// 通过任何形式构建好数据源，比如HikariCP、DBCP...
  private Pignoo pignoo = new BasePignoo(Test.dataSource);

  public void test() {
    var list = pignoo.writer(Pig.class);// 预加载数据

    List<Pig> pigs = list.getAll();// 查询

    Pig pig = list.add(new Pig(null, "新的小猪"));// 新增

    pig.setName("小猪改名");// 修改

    list.filter(Pig::getId, "==", pig.getId()).removeAll();// 删除
  }
}
`

</script>

<style lang="less"></style>